import { Injectable, Input } from '@angular/core';
import { IElementDataModel } from 'element/models/element.models';

@Injectable()
export abstract class ElementBaseComponent<T extends IElementDataModel> {
	@Input()
	public model: T = {} as T;
}
